export default function returnRequestStatusMapping(currentStatus, status) {
  const defaultReturn = 'Pending'
  // Check if it matches the status with current status
  if (typeof status[`${currentStatus}`] !== 'undefined') {
    return status[`${currentStatus}`]
  }
  return status[`${defaultReturn}`]
}
